// Internal targets that may be restored after a necessary sign-in: no query, hash, encoding, host or scheme.
const RESTORABLE = [/^\/community$/, /^\/community\/beitraege\/[A-Za-z0-9_-]{1,64}$/];

export function safeReturnPath(raw) {
  if (typeof raw !== "string" || raw.length > 100) return null;
  if (!raw.startsWith("/") || raw.startsWith("//") || /[^\x21-\x7e]|[\\%:?#@;]/.test(raw) || raw.includes("..")) return null;
  return RESTORABLE.some((re) => re.test(raw)) ? raw : null;
}

// After a session end (logout, expiry, rejection) nothing is carried over, so account B never lands on A's last view.
export const rememberTarget = (ended, pathname) => (ended ? null : safeReturnPath(pathname));

export const loginTarget = (ended, state) =>
  (!ended && state !== null && typeof state === "object" && safeReturnPath(state.from)) || "/";
